// Set withCredentials on request of specific environment
const withCredentials = {
  test: false,
  sit: false,
  uat: true,
  prod: true,
};

export default withCredentials;
